import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomizationDemoComponent } from './components/customization-demo/customization-demo.component';
import { CustomizationEditorComponent } from './components/customization-editor/customization-editor.component';
import { ColorPickerDirective } from 'ngx-color-picker';
import { ButtonModule } from '../button/button/button.module';
import { SideDialogModule } from '../side-dialog';
import { StoreModule } from '@ngrx/store';
import {
  customizationFeatureKey,
  customizationReducer,
} from './actions/reducers';
import { NavigationModule } from '../navigation/navigation.module';
import { CustomizationIconComponent } from './components/customization-icon/customization-icon.component';
import { MatIconModule } from '@angular/material/icon';
import { BottomIconModule } from '../bottom-icon/bottom-icon.module';
import { TranslationsModule } from 'ZalamoLibrary/src/lib/ui/nls/translations/translations.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { GetCurrentVariableValuePipe } from './components/get-current-variable-value.pipe';

@NgModule({
  declarations: [
    CustomizationDemoComponent,
    CustomizationEditorComponent,
    CustomizationIconComponent,
    GetCurrentVariableValuePipe,
  ],
  imports: [
    CommonModule,
    ColorPickerDirective,
    ButtonModule,
    SideDialogModule,
    StoreModule.forFeature(customizationFeatureKey, {
      customization: customizationReducer,
    }),
    NavigationModule,
    MatIconModule,
    BottomIconModule,
    TranslationsModule,
    MatExpansionModule,
  ],
  exports: [CustomizationIconComponent],
})
export class CustomizationModule {}
